import { Component, forwardRef, input, signal } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ColorPickerDirective } from 'ngx-color-picker';

@Component({
  selector: 'app-color-input',
  template: `
    <span
      [colorPicker]="value()"
      (colorPickerSelect)="onColorChange($event)"
      [cpDialogDisplay]="'popup'"
      [cpPosition]="'fixed'"
      [cpUseRootViewContainer]="true"
      [cpOKButton]="true"
      [cpOKButtonText]="'✓'"
      [cpOKButtonClass]="'btn btn-icon btn-sm btn-primary'"
      [cpCancelButton]="true"
      [cpCancelButtonText]="'✗'"
      [cpCancelButtonClass]="'btn btn-icon btn-sm btn-danger-outline'"
      [style.background-color]="value()"
      class="color-preview"
      data-testid="color-preview"
      [class.active]="!isDisabled()"
      [class.round]="isRound()"></span>
  `,
  styles: `
    :host {
      display: inline-flex;
      align-items: center;
    }
  `,
  host: {
    'data-testid': 'color-input',
    '[class.deactivate]': 'isDisabled()',
    '(click)': '$event.stopPropagation()',
    '(mousedown)': '$event.stopPropagation()',
  },
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ColorInput),
      multi: true,
    },
  ],
  imports: [ColorPickerDirective],
})
export class ColorInput implements ControlValueAccessor {
  readonly isRound = input<boolean>(false);

  protected readonly value = signal<string>('#000');
  protected readonly isDisabled = signal(false);
  private onChange: (value: string) => void;
  private onTouched: () => void;
  protected onColorChange(newColor: string): void {
    if (!this.isDisabled()) {
      this.value.set(newColor);
      this.onChange(newColor);
      this.onTouched();
    }
  }

  public writeValue(color: string) {
    this.value.set(color);
  }
  public registerOnChange(fn: (value: string) => void) {
    this.onChange = fn;
  }
  public registerOnTouched(fn: () => void) {
    this.onTouched = fn;
  }
  public setDisabledState?(isDisabled: boolean): void {
    this.isDisabled.set(isDisabled);
  }
}
